import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=b88bb472&scoped=true"
import script from "./activity-list.vue?vue&type=script&lang=js"
export * from "./activity-list.vue?vue&type=script&lang=js"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=b88bb472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88bb472",
  null
  
)

export default component.exports